(function () {
  var DESKTOP_MQ = '(min-width: 769px)';
  var CUT_EARLY = 0.08;
  var REWIND_HIDDEN_MS = 700;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function videoBelongsToViewport(video) {
    var desktopOnly = video.classList.contains('small--hide');
    var mobileOnly = video.classList.contains('medium-up--hide');
    if (desktopOnly && !mobileOnly) return isDesktop();
    if (mobileOnly && !desktopOnly) return !isDesktop();
    return true;
  }

  function slideOf(video) {
    return video ? video.closest('.slideshow__slide') : null;
  }

  function isSelectedVideo(video) {
    var slide = slideOf(video);
    return !!(slide && slide.classList.contains('is-selected') && videoBelongsToViewport(video));
  }

  function getFlickity(slideshowEl) {
    return window.Flickity && slideshowEl ? Flickity.data(slideshowEl) : null;
  }

  function stopFlickity(flkty) {
    if (!flkty) return;
    if (typeof flkty.stopPlayer === 'function') flkty.stopPlayer();
    else if (typeof flkty.pausePlayer === 'function') flkty.pausePlayer();
  }

  function startFlickity(flkty) {
    if (!flkty || !flkty.options.autoPlay) return;
    if (typeof flkty.playPlayer === 'function') flkty.playPlayer();
  }

  function activeVideoIn(slide) {
    if (!slide) return null;
    var found = null;
    slide.querySelectorAll('[data-slideshow-video]').forEach(function (video) {
      if (videoBelongsToViewport(video)) found = video;
    });
    return found;
  }

  function coverPoster(video, covered) {
    var slide = slideOf(video);
    if (!slide) return;
    slide.querySelectorAll('.hero__video-poster').forEach(function (img) {
      img.classList.toggle('is-covered', !!covered);
    });
  }

  function detachAdvance(video) {
    if (!video) return;
    ['timeupdate', 'playing', 'ended', 'canplay', 'loadeddata', 'error'].forEach(function (evt) {
      var key = '_oznOn' + evt;
      if (video[key]) {
        video.removeEventListener(evt, video[key]);
        video[key] = null;
      }
    });
  }

  function clearAdvance(slideshowEl) {
    if (!slideshowEl) return;
    if (slideshowEl._oznVideoTimer) {
      clearTimeout(slideshowEl._oznVideoTimer);
      slideshowEl._oznVideoTimer = null;
    }
    if (slideshowEl._oznKeepAlive) {
      clearTimeout(slideshowEl._oznKeepAlive);
      slideshowEl._oznKeepAlive = null;
    }
    if (slideshowEl._oznRewindTimer) {
      clearTimeout(slideshowEl._oznRewindTimer);
      slideshowEl._oznRewindTimer = null;
    }
    slideshowEl.classList.remove('ozn-video-hold');
    slideshowEl._oznHoldingVideo = null;
  }

  function attachSrc(video) {
    if (!video || !video.dataset.videoSrc) return;
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');
    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.loop = false;
    if (video.getAttribute('src') === video.dataset.videoSrc) return;
    video.preload = 'auto';
    video.src = video.dataset.videoSrc;
  }

  function freezeFrame(video) {
    if (!video) return;
    detachAdvance(video);
    video.loop = false;
    try {
      video.pause();
    } catch (e) {}
  }

  function rewindHidden(video) {
    if (!video || isSelectedVideo(video)) return;
    detachAdvance(video);
    try {
      video.pause();
    } catch (e) {}
    try {
      if (video.readyState > 0 && (video.ended || video.currentTime > 0.05)) {
        video.currentTime = 0.04;
      }
    } catch (e2) {}
    coverPoster(video, false);
  }

  function prefetchUpcoming(slideshowEl) {
    var slides = slideshowEl.querySelectorAll('.slideshow__slide');
    var selected = slideshowEl.querySelector('.slideshow__slide.is-selected');
    var idx = Array.prototype.indexOf.call(slides, selected);
    if (idx < 0) idx = 0;

    [idx + 1, idx + 2].forEach(function (i) {
      var slide = slides[i % slides.length];
      if (!slide || slide === selected) return;
      var video = activeVideoIn(slide);
      if (video) attachSrc(video);
    });
  }

  function tryPlay(video) {
    if (!video || !isSelectedVideo(video) || prefersReducedMotion()) return;
    attachSrc(video);
    video.muted = true;
    video.playsInline = true;
    video.loop = false;
    if (video.ended || (video.duration && video.currentTime >= video.duration - 0.15)) {
      try {
        video.currentTime = 0.04;
      } catch (e) {}
    }
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function holdUntilPlayed(slideshowEl, video) {
    var flkty = getFlickity(slideshowEl);
    if (!flkty || !flkty.options.autoPlay || !video) return;

    if (slideshowEl._oznHoldingVideo === video) {
      stopFlickity(flkty);
      tryPlay(video);
      return;
    }

    stopFlickity(flkty);
    clearAdvance(slideshowEl);
    detachAdvance(video);
    slideshowEl._oznHoldingVideo = video;
    slideshowEl.classList.add('ozn-video-hold');

    var token = (slideshowEl._oznVideoToken = (slideshowEl._oznVideoToken || 0) + 1);
    var advanced = false;

    function isCurrent() {
      return slideshowEl._oznVideoToken === token && !advanced && slideshowEl._oznHoldingVideo === video;
    }

    function goNext() {
      if (!isCurrent()) return;
      advanced = true;
      freezeFrame(video);
      clearAdvance(slideshowEl);
      if (flkty && typeof flkty.next === 'function') flkty.next();
    }

    function armTimer() {
      if (!isCurrent() || video._oznPlayedThisVisit) return;
      if (!video.duration || !isFinite(video.duration) || video.paused) return;
      video._oznPlayedThisVisit = true;
      slideshowEl.classList.remove('ozn-video-hold');
      coverPoster(video, true);
      var remaining = Math.max(40, (video.duration - CUT_EARLY - video.currentTime) * 1000);
      clearTimeout(slideshowEl._oznVideoTimer);
      slideshowEl._oznVideoTimer = setTimeout(function () {
        if (isCurrent()) goNext();
      }, remaining);
    }

    video._oznPlayedThisVisit = false;

    video._oznOntimeupdate = function () {
      if (!isCurrent()) return;
      if (!video.paused && video.currentTime > 0.05) {
        coverPoster(video, true);
        armTimer();
      }
      if (!video.duration || !isFinite(video.duration)) return;
      if (video.currentTime >= video.duration - CUT_EARLY && video.currentTime > 0.12) goNext();
    };
    video.addEventListener('timeupdate', video._oznOntimeupdate);

    video._oznOnplaying = function () {
      if (!isCurrent()) return;
      coverPoster(video, true);
      armTimer();
    };
    video.addEventListener('playing', video._oznOnplaying);

    video._oznOnended = function () {
      if (isCurrent()) goNext();
    };
    video.addEventListener('ended', video._oznOnended);

    video._oznOncanplay = function () {
      if (isCurrent()) tryPlay(video);
    };
    video.addEventListener('canplay', video._oznOncanplay);

    video._oznOnerror = function () {
      if (!isCurrent()) return;
      var speed = typeof flkty.options.autoPlay === 'number' ? flkty.options.autoPlay : 4000;
      slideshowEl._oznVideoTimer = setTimeout(function () {
        if (isCurrent()) goNext();
      }, speed);
    };
    video.addEventListener('error', video._oznOnerror, { once: true });

    tryPlay(video);

    function keepAlive() {
      if (!isCurrent()) return;
      if (video.paused && !video.ended) tryPlay(video);
      slideshowEl._oznKeepAlive = setTimeout(keepAlive, 280);
    }
    keepAlive();
  }

  function freezeOutgoingVideos(slideshowEl) {
    var selected = slideshowEl.querySelector('.slideshow__slide.is-selected');
    slideshowEl.querySelectorAll('.slideshow__slide').forEach(function (slide) {
      if (slide === selected) return;
      slide.querySelectorAll('[data-slideshow-video]').forEach(freezeFrame);
    });
  }

  function rewindHiddenLater(slideshowEl) {
    if (slideshowEl._oznRewindTimer) clearTimeout(slideshowEl._oznRewindTimer);
    slideshowEl._oznRewindTimer = setTimeout(function () {
      var selected = slideshowEl.querySelector('.slideshow__slide.is-selected');
      slideshowEl.querySelectorAll('.slideshow__slide').forEach(function (slide) {
        if (slide === selected || slide.classList.contains('animate-out')) return;
        slide.querySelectorAll('[data-slideshow-video]').forEach(rewindHidden);
      });
    }, REWIND_HIDDEN_MS);
  }

  function syncSlideshow(root) {
    if (!root) return;
    var slides = root.querySelectorAll('.slideshow__slide');
    if (!slides.length) return;

    var selected = root.querySelector('.slideshow__slide.is-selected') || slides[0];
    var flkty = getFlickity(root);
    var autoplayOn = !!(flkty && flkty.options.autoPlay);
    var activeVideo = activeVideoIn(selected);

    slides.forEach(function (slide) {
      if (slide === selected) return;
      slide.querySelectorAll('[data-slideshow-video]').forEach(freezeFrame);
    });

    prefetchUpcoming(root);

    if (!autoplayOn || slides.length < 2) {
      if (activeVideo && !prefersReducedMotion()) {
        activeVideo.loop = true;
        tryPlay(activeVideo);
      }
      return;
    }

    if (activeVideo && !prefersReducedMotion()) {
      holdUntilPlayed(root, activeVideo);
    } else {
      clearAdvance(root);
      startFlickity(flkty);
    }
  }

  function bindFlickity(slideshowEl) {
    if (!slideshowEl || slideshowEl.dataset.oznVideoBound === 'true') return;
    slideshowEl.dataset.oznVideoBound = 'true';

    var tries = 0;
    (function poll() {
      var flkty = getFlickity(slideshowEl);
      if (flkty) {
        flkty.on('change', function () {
          freezeOutgoingVideos(slideshowEl);
          var incoming = slideshowEl.querySelector('.slideshow__slide.is-selected');
          var incomingVideo = activeVideoIn(incoming);
          if (incomingVideo && flkty.options.autoPlay && !prefersReducedMotion()) {
            stopFlickity(flkty);
            holdUntilPlayed(slideshowEl, incomingVideo);
          } else {
            clearAdvance(slideshowEl);
          }
          prefetchUpcoming(slideshowEl);
          rewindHiddenLater(slideshowEl);
        });
        flkty.on('settle', function () {
          var selected = slideshowEl.querySelector('.slideshow__slide.is-selected');
          var activeVideo = activeVideoIn(selected);
          if (activeVideo && flkty.options.autoPlay && !prefersReducedMotion()) {
            stopFlickity(flkty);
            holdUntilPlayed(slideshowEl, activeVideo);
          } else {
            syncSlideshow(slideshowEl);
          }
          rewindHiddenLater(slideshowEl);
        });
        syncSlideshow(slideshowEl);
        setTimeout(function () {
          prefetchUpcoming(slideshowEl);
        }, 200);
        return;
      }
      if (++tries < 50) {
        setTimeout(poll, 50);
      } else {
        syncSlideshow(slideshowEl);
      }
    })();
  }

  function init(scope) {
    var root = scope || document;
    var sections = [];

    if (root.matches && root.matches('[data-section-type="slideshow-section"]')) {
      sections = [root];
    } else {
      sections = Array.prototype.slice.call(root.querySelectorAll('[data-section-type="slideshow-section"]'));
    }

    sections.forEach(function (section) {
      var slideshow = section.querySelector('[id^="Slideshow-"]');
      if (slideshow) bindFlickity(slideshow);
      else syncSlideshow(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (evt) {
    init(evt.target);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    document.querySelectorAll('[id^="Slideshow-"]').forEach(function (el) {
      var selected = el.querySelector('.slideshow__slide.is-selected');
      var video = activeVideoIn(selected);
      if (video) tryPlay(video);
    });
  });

  if (window.matchMedia) {
    var mq = window.matchMedia(DESKTOP_MQ);
    if (mq.addEventListener) {
      mq.addEventListener('change', function () {
        document.querySelectorAll('[id^="Slideshow-"]').forEach(syncSlideshow);
      });
    }
  }
})();
